module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mint-layout-container-multiple-item",
    style: (_vm.styleComputed),
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec9a54ca","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/layout-container-multiple-item/src/layout-container-multiple-item.vue
// module id = 432
// module chunks = 0